var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backBtn"},[_c('a-button',{staticClass:"backBtn",on:{"click":function($event){return _vm.$emit('backChange')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }